import _import from '../_import'

export default [{
  path: '/externals',
  name: 'external',
  component: _import('layout/Layout'),
  redirect: '/externals/linked',
  children: [{
    path: 'linked',
    name: 'external-linked-list',
    component: _import('external/ExternalLinkedList'),
    meta: {
      module: 'external',
      tab: 'linked',
    },
  }, {
    path: 'pending',
    name: 'external-pending-list',
    component: _import('external/ExternalPendingList'),
    meta: {
      module: 'external',
      tab: 'pending',
    },
  }],
}]
